<div class="view-container">
  <div class="analytics" fxLayout="row" fxLayout.lt-md="column">
    <div fxFlex.gt-sm="50" fxFlex.gt-xs="100" fxFlex="100">
      <chart
        title="Totals"
        [subtitle]="true"
        [type]="'line'"
        [data]="totalsChartData"
        [labels]="totalsChartLabels"
        [colors]="totalsChartColors"
        [loading]="totalsChartLoading"
        [labelFormatter]="totalsLabelFormatter"
        [isDarkMode]="isDarkMode">
          Hourly product view totals for the past 24 hours
      </chart>
    </div>
    <div fxFlex.gt-sm="50" fxFlex.gt-xs="100" fxFlex="100">
      <chart
        title="Views"
        [subtitle]="true"
        [type]="'bar'"
        [data]="viewsChartData"
        [labels]="viewsChartLabels"
        [colors]="viewsChartColors"
        [loading]="viewsChartLoading"
        [isDarkMode]="isDarkMode">
          Most popular products in the past 24 hours
      </chart>
    </div>
  </div>
  <div *ngIf="isSituUser || isPartnerAdmin" class="products" fxLayout="row" fxLayout.lt-md="column">
    <mat-card *ngIf="isSituUser" [fxFlex.gt-sm]="isSituUser ? 50 : 100" fxFlex.gt-xs="100" fxFlex="100">
      <mat-card-content>
        <div class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="0px" fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
          <label>Your products</label>
          <div fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column" fxLayoutAlign="end center" fxLayoutAlign.lt-sm="start center">
            <a *ngIf="this.admin"
              [@cardAnimator]="animateGetStarted"
              (@cardAnimator.done)="animateGetStarted = ''" 
              mat-mini-fab color="accent" aria-label="Download Bulk Import Template" matTooltip="Download Bulk Import Template" href="https://cdn.situsystems.com/product-templates/product_template.xlsx">
              <mat-icon>file_download</mat-icon>
            </a>
            <button 
              [@cardAnimator]="animateGetStarted"
              (@cardAnimator.done)="animateGetStarted = ''" 
              mat-flat-button type="button"
              color="accent"
              aria-label="Bulk Import"
              matTooltip="Bulk Import"
              (click)="onImportProductsClick()">
              <mat-icon><span class="material-icons">file_upload</span></mat-icon> Bulk Import
              <input class="upload-input" id="uploaded-product-file"
                [(ngModel)]="filename" type="file" (change)="onFileChosen($event)" accept=".xlsx" />
            </button>
            <button
              [@cardAnimator]="animateGetStarted"
              (@cardAnimator.done)="animateGetStarted = ''" 
              mat-flat-button type="button"
              color="accent"
              aria-label="Add Product"
              [matTooltip]="(productsDataSource.data?.length > 0 || searchTerm ? 'Add Product' : 'Add Product to get started!')"
              (click)="onClickAddProduct()">
              <mat-icon>add</mat-icon> Add Product
            </button>
          </div>
        </div>
        <mat-card *ngIf="productsDataSource.data?.length > 0 || searchTerm" [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
          <mat-card-content>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="start center" fxFlex>
              <mat-form-field fxFlex="80" class="accent">
                <mat-label>Search</mat-label>
                <input matInput type="text"
                  [(ngModel)]="searchTerm"
                  (keyup.enter)="loadProducts()"
                  (keyup.esc)="searchTerm=''; loadProducts()"
                  name="searchTerm" placeholder="Search Description or SKU">
                <button type="reset" mat-button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="searchTerm=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
              <div fxLayout="row" fxLayoutAlign="start center" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="start center" fxFlex="20">
                <div fxLayout="row" fxLayoutGap="15px">
                  <button mat-flat-button type="submit" (click)="loadProducts()" color="primary">
                    <mat-icon>search</mat-icon> Search
                  </button>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card class="banner-error" *ngIf="(!productsDataSource.data?.length && !loading) && (productsDataSource.data?.length > 0 || searchTerm)">
          <mat-card-content>
            No products match that search criteria
          </mat-card-content>
        </mat-card>
        <mat-card class="banner-info" *ngIf="!productsDataSource.data?.length && loading && searchTerm">
          <mat-card-content>
            Searching products for <em>"{{ searchTerm }}"...</em>
          </mat-card-content>
        </mat-card>
        <mat-card class="banner-info" *ngIf="!productsDataSource.data?.length && loading && !searchTerm">
          <mat-card-content>
            Searching products...
          </mat-card-content>
        </mat-card>
        <div *ngIf="!('tagRework' === 'tagRework') && productsDataSource?.data?.length > 0" cdkDropList [cdkDropListData]="productsDnD" (cdkDropListDropped)="processTagAction('remove')">
          <div cdkDrag [cdkDragDisabled]="getProductsSelected() < 1 || !selectedTag">
            <mat-card class="banner-success" 
              [class.draggable]="getProductsSelected() > 0 && selectedTag"
              [class.draggable-right]="getProductsSelected() > 0 && selectedTag"  
              [class.contrast]="selectMode"
              [class.banner-incomplete]="!selectMode"
              [ngClass.lt-lg]="{'mat-card-inline-sm': true}">
              <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
                <div fxFlex="60" fxLayoutAlign="start center" fxLayout="row">
                  <mat-icon *ngIf="!selectMode" class="m-r-5">done</mat-icon>
                  <strong *ngIf="!selectMode" class="text-center" [ngClass.lt-sm]="{'card-title': true}">to select</strong>
                  <strong *ngIf="selectMode" class="text-center" [ngClass.lt-sm]="{'card-title': true}"><span class="text-info">{{ getProductsSelected() }}</span> products selected</strong>
                </div>
                <div fxFlex="40" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
                  <div fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="center center" class="date-text">
                    <button *ngIf="selectMode"
                      mat-icon-button color="basic"
                      matTooltip="Cancel Select"
                      aria-label="Cancel Select"
                      (click)="toggleSelectMode();">
                      <mat-icon>clear</mat-icon>
                    </button>
                    <button *ngIf="!selectMode"
                      mat-icon-button color="accent"
                      matTooltip="Select Products"
                      aria-label="Select Products"
                      (click)="toggleSelectMode(); startAnimation('headShake')">
                      <mat-icon>done</mat-icon>
                    </button>
                    <button
                      mat-icon-button color="accent"
                      matTooltip="Select All Products"
                      aria-label="Select All Products"
                      (click)="toggleSelectAll()">
                      <mat-icon>done_all</mat-icon>
                    </button>
                    <button *ngIf="selectMode"
                      mat-icon-button color="warn"
                      matTooltip="Remove Tag"
                      aria-label="Remove Tag"
                      [disabled]="getProductsSelected() < 1 || !selectedTag"
                      (click)="processTagAction('remove')">
                      <mat-icon>keyboard_double_arrow_right</mat-icon>
                    </button>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
        <ng-container *ngFor="let item of productsDataSource.data">
          <product-card
            [animationState]="animateSelect"
            class="card-link"
            [item]="item"
            [readonly]="true"
            [searchValue]="searchTerm"
            (addTagEvent)="assignTagToProduct($event, item)"
            (removeTagEvent)="removeTagFromProduct($event, item)"
            [tags]="tags"
            [selected]="item.selected"
            (click)="onClickProduct(item)">
          </product-card>
        </ng-container>
        <mat-card *ngIf="productsDataSource?.data?.length > 0" [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
          <mat-paginator [length]="viewControls.totalItems" [pageSize]="viewControls.pageSize"
            [pageIndex]="viewControls.pageIndex" [pageSizeOptions]="viewControls.pageSizeOptions"
            (page)="onPageChange($event)">
          </mat-paginator>
        </mat-card>
      </mat-card-content>
    </mat-card>
    <mat-card fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
      <div *ngIf="loading">
        <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
      </div>
      <mat-card-content>
        <div class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="0px" fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
          <label>{{ (isNotTagFeed ? "Ranges" : "Tags") }} Feed <!-- | -->
            <!-- <span *ngIf="isNotTagFeed" class="text-warning ifc-link" (click)="toggleTagFeed()">Show Tags</span>
            <span *ngIf="!isNotTagFeed" class="text-success ifc-link" (click)="toggleTagFeed()">Show Ranges</span> -->
          </label>
          <button
            [matTooltip]="(isNotTagFeed ? 'Add Range' : 'Create Tag')"
            mat-flat-button type="button"
            color="accent" (click)="onClickAddRange()">
            <mat-icon>add</mat-icon> {{ (isNotTagFeed ? "Add Range" : "Create Tag") }}
          </button>
        </div>
        <!-- <mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
          <mat-card-content>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="start center" fxFlex>
              <mat-form-field fxFlex="100" class="accent">
                <mat-label>Search</mat-label>
                <input matInput type="text"
                  [formControl]="searchFieldTag"
                  (keyup)="doTagFilter($event.target.value)"
                  (keyup.esc)="$event.target.value=''; doTagFilter($event.target.value)"
                  placeholder="Search Tag Name">
                <button type="reset" mat-button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="searchTerm=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </mat-card-content>
        </mat-card> -->
        <ng-container *ngIf="isNotTagFeed">
          <range-list
            [admin]="admin"
            [company]="selectedCompany"
            [isDarkMode]="isDarkMode">
          </range-list>
        </ng-container>
        <ng-container *ngIf="!isNotTagFeed">
          <div *ngIf="selectMode" cdkDropList [cdkDropListData]="tagsDnD" (cdkDropListDropped)="processTagAction('apply')">
            <div cdkDrag [cdkDragDisabled]="getProductsSelected() < 1 || !selectedTag">
              <mat-card class="banner-success" 
                [class.draggable]="getProductsSelected() > 0 && selectedTag"
                [class.draggable-left]="getProductsSelected() > 0 && selectedTag"
                [class.contrast]="selectedTag"
                [class.banner-incomplete]="!selectedTag"
                [ngClass.lt-lg]="{'mat-card-inline-sm': true}">
                <mat-card-content fxLayoutAlign="center center" fxLayout="row-reverse" fxLayout.lt-sm="column">
                  <div fxFlex="60" fxLayoutAlign="end center" fxLayout="row">
                    <strong *ngIf="!selectedTag" class="text-center" [ngClass.lt-sm]="{'card-title': true}">select tag to apply</strong>
                    <div *ngIf="selectedTag" class="fake-tag m-r-5" [ngClass]="tagClass(selectedTag)">
                      <span>{{ selectedTag?.name }}</span>
                    </div>
                    <strong *ngIf="selectedTag" class="text-center" [ngClass.lt-sm]="{'card-title': true}">selected</strong>
                    <!-- <strong class="text-center" [ngClass.lt-sm]="{'card-title': true}"><span class="text-info">{{ getProductsSelected() }}</span> products selected</strong> -->
                  </div>
                  <div fxFlex="40" fxLayoutAlign="start center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
                    <div fxLayoutAlign="end center" fxLayout="row-reverse" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="center center" class="date-text">
                      <button
                        mat-icon-button color="basic"
                        matTooltip="Cancel Select"
                        aria-label="Cancel Select"
                        (click)="toggleSelectMode();">
                        <mat-icon>clear</mat-icon>
                      </button>
                      <button *ngIf="selectedTag"
                        mat-icon-button color="primary"
                        matTooltip="Apply Tag"
                        aria-label="Apply Tag"
                        [disabled]="getProductsSelected() < 1 || !selectedTag"
                        (click)="processTagAction('apply')">
                        <mat-icon>keyboard_double_arrow_left</mat-icon>
                      </button>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
          <mat-card *ngFor="let item of tags"
            [@cardAnimator]="animateSelect"
            (@cardAnimator.done)="resetAnimationState()" 
            class="contrast"
            [class.card-link]="selectMode"
            [class.banner-info]="selectedTag && selectedTag?.id === item?.id"
            [ngClass.lt-lg]="{'mat-card-inline-sm': true}"
            (click)="selectTag(item)">
            <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
              <div fxFlex="25" fxLayoutAlign="start center" fxLayout="row">
                <div class="fake-tag" [ngClass]="tagClass(item)">
                  <span>{{item?.name}}</span>
                </div>
                <!-- <strong class="text-center" [ngClass.lt-sm]="{'card-title': true}">{{ item?.name }}</strong> -->
              </div>
              <div fxFlex="75" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
                <div fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="center center" class="date-text">
                  <p><small>products tagged</small></p>
                  <div class="text-center" [ngClass.gt-xs]="{'m-l-5': true}">
                    <span class="text-info">{{ getProductsTagged(item) }}</span>
                  </div>
                  <!-- <div fxHide.lt-sm class="m-l-5 m-r-5">|</div>
                  <p><small>uploaded</small></p>
                  <div class="text-center" [ngClass.gt-xs]="{'m-l-5': true}">{{ item?.dateAdded | date:'short' }}</div> -->
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </ng-container>
      </mat-card-content>
    </mat-card>
  </div>
</div>
